import { defineMessages } from 'react-intl';

// The `generatedAt` message below uses ICU `selectordinal` to render the day with a
// language-specific ordinal suffix (e.g. "19th" in English). selectordinal is an ICU/i18n standard
// but is not natively supported by Smartling, so it is blocklisted by default — the localisation
// team's guidance is to use it anyway with linguist instructions in the `description` (see the
// `recur-work-item` precedent in jira/). The whole ordinal expression must live inside the full
// string (not a reused placeholder) so translators have context. These rules report on the
// `defineMessages` call node, so the disables must wrap the whole statement.
/* eslint-disable @atlassian/i18n/enforce-icu-format, @atlassian/i18n/blocklist-elements */
export const commonMessages: {
	generatedAt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	generatedAt: {
		id: 'rovo-growth-pulse.common.messages.generatedAt',
		defaultMessage:
			'Generated {day, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} {month}',
		description:
			'Date stamp showing when insights were generated, e.g. "Generated 19th May". {day} is the day of the month rendered with a language-specific ordinal suffix, {month} is the full month name. Translators: render the ordinal suffix (st/nd/rd/th) as appropriate for your language, or omit the suffix entirely if your language does not use ordinal suffixes for dates.',
	},
});
/* eslint-enable @atlassian/i18n/enforce-icu-format, @atlassian/i18n/blocklist-elements */
